import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableGiftcardPurchase',
  initialState: false,
  reducers: {
    setEnableGiftcardPurchase(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableGiftcardPurchase } = slice.actions;

export default slice.reducer;
